/**
 * Sensitive field names and patterns for PII scrubbing
 */
const SENSITIVE_FIELDS = [
  'cvv',
  'token',
  'trandata',
  'enc',
  'card_number',
  'card_cvv',
  'otp',
  'password',
  'pin',
  'secret',
];

/**
 * Regex patterns for detecting sensitive tokens and IDs in URLs and strings
 * These patterns match common sensitive data formats that might appear in URL paths
 */
const SENSITIVE_URL_PATTERNS = [
  // Session IDs: sess_alphanumeric, session_alphanumeric
  /\b(?:sess|session)_[a-zA-Z0-9]{6,}\b/gi,
  // Tokens: tok_alphanumeric, token_alphanumeric
  /\b(?:tok|token)_[a-zA-Z0-9]{6,}\b/gi,
  // API Keys: key_alphanumeric, api_alphanumeric, apikey_alphanumeric
  /\b(?:key|api|apikey)_[a-zA-Z0-9]{6,}\b/gi,
  // Reset tokens/keys: reset_alphanumeric, resetkey_alphanumeric
  /\b(?:reset|resetkey)_[a-zA-Z0-9]{6,}\b/gi,
  // Access tokens: access_alphanumeric, accesstoken_alphanumeric
  /\b(?:access|accesstoken)_[a-zA-Z0-9]{6,}\b/gi,
  // Auth tokens: auth_alphanumeric, authtoken_alphanumeric
  /\b(?:auth|authtoken)_[a-zA-Z0-9]{6,}\b/gi,
];

exports.SENSITIVE_FIELDS = SENSITIVE_FIELDS;
exports.SENSITIVE_URL_PATTERNS = SENSITIVE_URL_PATTERNS;
